import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import styled from 'styled-components'

const SelectBox = props => {
    return (
        <StyledForm required={props.required}>
            <InputLabel style={{paddingLeft:'12px'}}>{props.label}</InputLabel>
            <Select
                value={props.value} variant='filled'
                onChange={e => props.select(e.target.value)}
            >
                <MenuItem key='0' value="">選択してください</MenuItem>
                {props.options.map((option) => (
                    <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                ))}
            </Select>
        </StyledForm>
    )
}
export default SelectBox

const StyledForm = styled(FormControl)`
    margin-bottom: 16px;
    min-width: 128px;
    width: 100%;
`